var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconCancel = function SvgIconCancel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.97363 0.000244141C3.56967 0.000244141 0 3.56997 0 7.97337C0 12.3773 3.56967 15.947 7.97363 15.947C12.3776 15.947 15.9473 12.3773 15.9473 7.97337C15.9473 3.57047 12.3775 0.000244141 7.97363 0.000244141ZM9.38548 7.96791L10.7948 6.55857C10.9897 6.36323 10.9897 6.04824 10.7948 5.8539L10.0901 5.14873C9.8953 4.95439 9.58032 4.95389 9.38548 5.14873L7.97564 6.55857L6.5668 5.14974C6.37146 4.95439 6.05597 4.95439 5.86113 5.14873L5.15646 5.8539C4.96162 6.04824 4.96212 6.36423 5.15746 6.55907L6.5663 7.96791L5.15992 9.37424C4.96507 9.56908 4.96507 9.88406 5.15992 10.0789L5.86459 10.7841C6.05943 10.9784 6.37441 10.9789 6.56925 10.7841L7.97558 9.37775L9.39189 10.7946C9.58723 10.9899 9.90272 10.9899 10.0976 10.7951L10.8022 10.0904C10.9971 9.89555 10.9966 9.58006 10.8017 9.38472L9.38548 7.96791ZM1.49508 7.97343C1.49508 11.5516 4.39548 14.452 7.97363 14.452C11.5518 14.452 14.4522 11.5515 14.4522 7.97337C14.4522 4.39523 11.5518 1.49482 7.97363 1.49482C4.39548 1.49482 1.49508 4.39528 1.49508 7.97343Z",
    fill: "#E2574C"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCancel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-cancel.222acc71.svg";
export { ForwardRef as ReactComponent };